import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import compose from "recompose/compose";
import withWidth from "@material-ui/core/withWidth";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const styles = (theme) => ({
  root: {
    textAlign: "center",
    marginTop: theme.spacing(10),
  },
});

class NextBackButtons extends Component {
  render() {
    const {
      classes,
      backOnClick,
      disableBack,
      nextOnClick,
      disableBoth,
      nextLabel,
    } = this.props;

    return (
      <Hidden smDown>
        <Grid container direction="row" className={classes.root}>
          <Grid item xs>
            <Button
              disabled={disableBack || disableBoth}
              onClick={backOnClick}
              startIcon={<ArrowBackIcon />}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs>
            <Button
              disabled={disableBoth}
              variant="contained"
              color="primary"
              type={nextOnClick ? "button" : "submit"} // if there's a nextOnClick, make this a button. Else, just be a submit button
              onClick={nextOnClick || null} // if there's a nextOnClick, use it. If not, don't have an onclick - use submit instead
              endIcon={<ArrowForwardIcon />}
            >
              {nextLabel ? nextLabel : "Continue"}
            </Button>
          </Grid>
        </Grid>
      </Hidden>
    );
  }
}

NextBackButtons.propTypes = {
  classes: PropTypes.object.isRequired,
  backOnClick: PropTypes.func,
  disableBack: PropTypes.bool,
  nextOnClick: PropTypes.func,
  disableBoth: PropTypes.bool,
  nextLabel: PropTypes.string,
};

export default compose(withStyles(styles), withWidth())(NextBackButtons);
